export enum BrandSecondaryColorToken {
  brandColorSecondaryPure = '#F1F1F1',
  brandColorSecondaryLight = '#FAFAFA',
  brandColorSecondaryMedium = '#E3E3E3',
  brandColorSecondaryDark = '#D2D2D2',
}

export default BrandSecondaryColorToken

export type TSecondary =
  | 'brandColorSecondaryPure'
  | 'brandColorSecondaryLight'
  | 'brandColorSecondaryMedium'
  | 'brandColorSecondaryDark'
